import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileLandscape } from 'react-device-detect';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TournamentDropdownFilter from './TournamentDropdownFilter';
import '../../../../../../../assets/stylesheets/TournamentCasino/TournamentFilters.scss';

const TournamentFilters = ({
  selectedTop, onChangeSelectedTop,
  search, onChangeSearch,
  states, selectedState, onChangeSelectedState,
  selectedCategories, onChangeSelectedCategories,
  tournaments
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const stateInTimeCategories = ['normal', 'addedPrizes', 'guaranteed', 'jackpot', 'freeroll'];
  const stateInTimeTypes = ['scheduledTournaments', 'sngTournaments', 'myTournaments'];

  return (
    <div className={`tournaments-filter ${show ? 'show-filters' : ''}`}>
      { !isMobileLandscape && <Fragment>
        <div className="tournaments-filter__header">
          <button onClick={() => setShow(show => !show)} className="tournaments-filter__button">
            <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
              <title>371469B5-C130-4FFE-849F-237F41AFD63B</title>
              <desc>Created with sketchtool.</desc>
              <g id="Casino-Tournaments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Casino-Filters" transform="translate(-29.000000, -173.000000)" fill="#019DFF" fill-rule="nonzero">
                  <g id="sliders-v-alt" transform="translate(29.000000, 173.000000)">
                    <path d="M14.4,4.944 L14.4,0.8 C14.4,0.3581722 14.0418278,0 13.6,0 C13.1581722,0 12.8,0.3581722 12.8,0.8 L12.8,4.944 C11.8508372,5.28850008 11.2188187,6.19025239 11.2188187,7.2 C11.2188187,8.20974761 11.8508372,9.11149992 12.8,9.456 L12.8,15.2 C12.8,15.6418278 13.1581722,16 13.6,16 C14.0418278,16 14.4,15.6418278 14.4,15.2 L14.4,9.456 C15.3491628,9.11149992 15.9811813,8.20974761 15.9811813,7.2 C15.9811813,6.19025239 15.3491628,5.28850008 14.4,4.944 Z M13.6,8 C13.1581722,8 12.8,7.6418278 12.8,7.2 C12.8,6.7581722 13.1581722,6.4 13.6,6.4 C14.0418278,6.4 14.4,6.7581722 14.4,7.2 C14.4,7.6418278 14.0418278,8 13.6,8 Z M8.8,9.744 L8.8,0.8 C8.8,0.3581722 8.4418278,0 8,0 C7.5581722,0 7.2,0.3581722 7.2,0.8 L7.2,9.744 C6.25083725,10.0885001 5.61881866,10.9902524 5.61881866,12 C5.61881866,13.0097476 6.25083725,13.9114999 7.2,14.256 L7.2,15.2 C7.2,15.6418278 7.5581722,16 8,16 C8.4418278,16 8.8,15.6418278 8.8,15.2 L8.8,14.256 C9.74916275,13.9114999 10.3811813,13.0097476 10.3811813,12 C10.3811813,10.9902524 9.74916275,10.0885001 8.8,9.744 Z M8,12.8 C7.5581722,12.8 7.2,12.4418278 7.2,12 C7.2,11.5581722 7.5581722,11.2 8,11.2 C8.4418278,11.2 8.8,11.5581722 8.8,12 C8.8,12.4418278 8.4418278,12.8 8,12.8 Z M3.2,3.344 L3.2,0.8 C3.2,0.3581722 2.8418278,0 2.4,0 C1.9581722,0 1.6,0.3581722 1.6,0.8 L1.6,3.344 C0.650837249,3.68850008 0.0188186612,4.59025239 0.0188186612,5.6 C0.0188186612,6.60974761 0.650837249,7.51149992 1.6,7.856 L1.6,15.2 C1.6,15.6418278 1.9581722,16 2.4,16 C2.8418278,16 3.2,15.6418278 3.2,15.2 L3.2,7.856 C4.14916275,7.51149992 4.78118134,6.60974761 4.78118134,5.6 C4.78118134,4.59025239 4.14916275,3.68850008 3.2,3.344 Z M2.4,6.4 C1.9581722,6.4 1.6,6.0418278 1.6,5.6 C1.6,5.1581722 1.9581722,4.8 2.4,4.8 C2.8418278,4.8 3.2,5.1581722 3.2,5.6 C3.2,6.0418278 2.8418278,6.4 2.4,6.4 Z" id="Shape" />
                  </g>
                </g>
              </g>
            </svg>
            <span>Filters</span>
          </button>
          <div className="tournaments-filter__search">
            <FontAwesomeIcon className="tournaments-filter__search-icon" icon={faSearch} />
            <input
              type="text"
              className="tournaments-filter__search-input"
              value={search}
              onChange={onChangeSearch}
              placeholder={t('tournaments.searchTournament')}
            />
          </div>
        </div>
        <div className="tournaments-filter__body">
          <div className="tournaments-filter__body-top">
            <TournamentDropdownFilter
              options={stateInTimeTypes}
              selected={selectedTop}
              neutral={'allTypes'}
              onChange={onChangeSelectedTop}
              removeSelectedOption
            />
          </div>
          <div className="tournaments-filter__body-bottom">
            <TournamentDropdownFilter
              options={stateInTimeCategories}
              selected={selectedCategories}
              neutral={'allCategories'}
              removeSelectedOption
            />
            <TournamentDropdownFilter
              options={states}
              selected={selectedState}
              onChange={onChangeSelectedState}
              neutral={'allStates'}
              removeSelectedOption
            />
          </div>
        </div>
      </Fragment>}
      {isMobileLandscape && <div className="tournaments__filters">
        <div className="tournaments__filters__serach-filterBtn-wrapper">
          <div className="tournaments__top-filters--search">
            <div className="tournaments__filters__search">
              <FontAwesomeIcon className="tournaments__filters__search-icon" icon={faSearch} />
              <input
                type="text"
                className="tournaments__filters__search-input"
                value={search}
                onChange={onChangeSearch}
                placeholder={t('tournaments.searchTournament')}
              />
            </div>
          </div>
          <div className="tournaments__top-filters--filertBtn-wrapper">
            <div onClick={() => setShow(show => !show)} className="tournaments__top-filters--filertBtn">
              <i className="icon-live"></i>
              <span>filter</span>
            </div>
          </div>
        </div>
        {show && <div className="tournaments__filters__types-categories-states-wrapper">
          <div className="tournaments__filters__types-wrapper">
            <div className="tournaments__top-filters--types">
              <TournamentDropdownFilter
                options={stateInTimeTypes}
                selected={selectedTop}
                neutral={'allTypes'}
                onChange={onChangeSelectedTop}
                removeSelectedOption
              />
            </div>
          </div>
          <div className="tournaments__filters__categories-states-wrapper">
            <TournamentDropdownFilter
              options={states}
              selected={selectedState}
              onChange={onChangeSelectedState}
              neutral={'allStates'}
              removeSelectedOption
            />
          </div>
        </div>}
      </div>}
    </div>
  );
}

export default TournamentFilters;
